import { NgModule } from "@angular/core";
import { CustomslizePipe } from './customslize.pipe';
import { HighlightPipe } from "./highlight.pipe";
import { SafeUrlPipe } from './safeUrl.pipe';

@NgModule({
  declarations: [
    CustomslizePipe,
    HighlightPipe,
    SafeUrlPipe
  ],
  exports: [CustomslizePipe, HighlightPipe, SafeUrlPipe]
})
export class PipesModule { }
